module.exports = __webpack_public_path__ + "img/archive-2.636ab339.png";